import {
  ADD_ROOM_IN_CART,
  REMOVE_ROOM_IN_CART,
  UPDATE_UPSALE_IN_CART,
  UPDATE_ROOM_PRICE_IN_CART,
  SET_VOUCHER,
  RESET_IN_CART,
  SET_TAX,
  SET_ROOMS_IN_CART,
} from "../_actions/types";
const initialState = {
  rooms: [],
  upsell: [],
  voucher: null,
  tax: 0,
};

const stateReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_ROOM_IN_CART:
      const existingRoom = state.rooms.find(
        (room) =>
          room.room_type_id === action.payload.room_type_id &&
          room.index === action.payload.index
      );
      if (existingRoom) {
        return {
          ...state,
          rooms: state.rooms.map((room) =>
            room.room_type_id === action.payload.room_type_id &&
              room.index === action.payload.index
              ? { ...room, count: room.count + 1 }
              : room
          ),
        };
      } else {
        return {
          ...state,
          rooms: [...state.rooms, action.payload],
        };
      }
    case REMOVE_ROOM_IN_CART:
      const roomToRemove = state.rooms.find(
        (room) =>
          room.room_type_id === action.payload.room_type_id &&
          room.index === action.payload.index
      );
      if (roomToRemove) {
        if (roomToRemove.count > 1) {
          return {
            ...state,
            rooms: state.rooms.map((room) =>
              room.room_type_id === action.payload.room_type_id &&
                room.index === action.payload.index
                ? { ...room, count: room.count - 1 }
                : room
            ),
          };
        } else {
          return {
            ...state,
            rooms: state.rooms.filter(
              (room) =>
                !(
                  room.room_type_id === action.payload.room_type_id &&
                  room.index === action.payload.index
                )
            ),
          };
        }
      }
      return state;
    case UPDATE_UPSALE_IN_CART:
      return {
        ...state,
        upsell: action.payload,
      };
    case SET_VOUCHER:
      return {
        ...state,
        voucher: action.payload,
      };
    case UPDATE_ROOM_PRICE_IN_CART:
      return {
        ...state,
        rooms: state.rooms.map((room) =>
          room.room_type_id === action.payload.room_type_id &&
            room.index === action.payload.index
            ? { ...room, price: action.payload.price }
            : room
        ),
      };
    case SET_ROOMS_IN_CART:
      return {
        ...state,
        rooms: Array.isArray(action.payload) ? action.payload : [],
      };
    case SET_TAX:
      return {
        ...state,
        tax: action.payload,
      };
    case RESET_IN_CART:
      return initialState;

    default:
      return state;
  }
};

export default stateReducer;
